function addClass (el, classNames) {
  let classes = (typeof classNames === 'object') ? classNames : [classNames]
  el.classList.add(...classes)
}

function removeClass (el, classNames) {
  let classes = (typeof classNames === 'object') ? classNames : [classNames]
  el.classList.remove(...classes)
}

function hasClass (el, classNames) {
  let classes = (typeof classNames === 'object') ? classNames : [classNames]
  return el.classList.contains(...classes)
}

export {
  addClass,
  removeClass,
  hasClass
}
